
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/how-to-buy-bsv",
      function () {
        return require("private-next-pages/how-to-buy-bsv.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/how-to-buy-bsv"])
      });
    }
  